import moment from 'moment';

// How long an approval stays good for when the API doesn't tell us outright.
export const APPROVAL_VALID_DAYS = 60;

// US month-first, as the in-store copy reads: "12/11/2026" is December 11.
export const APPROVAL_DATE_FORMAT = 'MM/DD/YYYY';

// Accepted input: ISO dates/timestamps from the API, or an already US-formatted date.
// Parsed strictly - moment's loose fallback guesses at day/month order.
const INPUT_FORMATS = [moment.ISO_8601, APPROVAL_DATE_FORMAT];

const fallback = () => moment().add(APPROVAL_VALID_DAYS, 'days').format(APPROVAL_DATE_FORMAT);

/**
 * The date an approval stops being usable, formatted MM/DD/YYYY - e.g. "09/30/2026".
 *
 * The checkout payload has no expiration field today, so this falls back to the
 * standard 60-day window from now. Pass `expiresAt` through once the API exposes it.
 */
export default function getApprovalExpiration(expiresAt) {
  if (!expiresAt) return fallback();

  const expiration = moment(expiresAt, INPUT_FORMATS, true);
  return expiration.isValid() ? expiration.format(APPROVAL_DATE_FORMAT) : fallback();
}
